import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const AllRoutes = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M0 0H24V24H0V0Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0)">
        <path d="M0 0H24V4H0V0Z" fill={props.fill ? props.fill : "white"} />
        <path
          d="M0 6.5H24V10.5H0V6.5Z"
          fill={props.fill ? props.fill : "white"}
        />
        <path
          d="M0 13.5H24V17.5H0V13.5Z"
          fill={props.fill ? props.fill : "white"}
        />
        <path d="M0 20H24V24H0V20Z" fill={props.fill ? props.fill : "white"} />
      </g>
    </SvgIcon>
  );
});
